<template>
  <SimpleFieldBool
    :disabled="disabled"
    :operators="operators"
    :value.sync="mutableValue"/>
</template>
<script>
import SimpleFieldBool from 'components/automation/conditions/default/simpleFieldBool.vue'

/**
 * 11
 */
export default {
  name: 'existenceOfCriteries',
  computed: {
    mutableValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('update:value', newValue)
      }
    },
  },
  components: {
    SimpleFieldBool
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    },
  },
}
</script>
